import React from 'react'
import { createRoot } from 'react-dom/client';

export default function ReactComponentLoader (components)
{
  document
    .querySelectorAll('[data-react-component]')
    .forEach((elm) => {
      if (!components[elm.dataset.reactComponent]) return
      let ReactComponent = components[elm.dataset.reactComponent]
      let props = elm.dataset.reactProps ? JSON.parse(elm.dataset.reactProps) : {}
      createRoot(elm).render(<ReactComponent {...props} />);
  });
}
